import { useState, useEffect } from 'react';
import SelectInput from './SelectInput';
import useCourseData from '../../hooks/UseCourseData';

const CourseSelectInput = ({ register, errors, name, label = "Course", validationRules = { required: 'Course is required' }, fullWidth = true }) => {
  const { courses, loading } = useCourseData();
  const [courseOptions, setCourseOptions] = useState([]);

  useEffect(() => {
    setCourseOptions(courses.map(course => ({
      value: course.id,
      label: `${course.code} - ${course.title}`
    })));
  }, [courses]);

  if (loading) {
    return <p>Loading courses...</p>;
  }



  return (
    <SelectInput
      label={label}
      name={name}
      register={register}
      errors={errors}
      options={courseOptions}
      validationRules={validationRules}
      fullWidth={fullWidth}
    />
  );
};

export default CourseSelectInput;
